<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_xxiii">DRAMATIS PERSONAE</a></p><a id="page_xxiii">
<p class="fma"><i>(in order of appearance)</i></p>
<table cellpadding="0" cellspacing="0" class="table1" width="100%">
<colgroup><col width="40%"/>
<col width="60%"/>
</colgroup><tbody><tr>
<td><p class="tabh">Huun-Huur-Tu</p></td>
<td><p class="tabh1b">Four-person musical group from Tuva, whose members include:</p>
<p class="tabh2">Sayan Bapa</p>
<p class="tabh2">Anatoli (Tolya) Kuular*</p>
<p class="tabh2">Kaigal-ool Xovalyg</p>
<p class="tabh2b">Alexei Saryglar</p></td>
</tr>
<tr>
<td><p class="tabh">Alexander Cheparukhin</p></td>
<td><p class="tabh1">Huun-Huur-Tu’s manager</p></td>
</tr>
<tr>
<td><p class="tabh">Eduard Alekseyev</p></td>
<td><p class="tabh1">Russian-Sakha specialist in Siberian music who participated in 1987–1988 Tuva expeditions</p></td>
</tr>
<tr>
<td><p class="tabh">Zoya Kyrgys</p></td>
<td><p class="tabh1">Tuvan folklorist and expert on <i>xöömei</i> (throat-singing) who participated in 1987–1988 Tuva expeditions</p></td>
</tr>
<tr>
<td><p class="tabh">Idamchap Xomushtu</p></td>
<td><p class="tabh1">Tuvan stringed instrument and jew’s harp player; important informant of Valentina Süzükei</p></td>
</tr>
<tr>
<td><p class="tabh">Alexander Bapa</p></td>
<td><p class="tabh1">Former member of Huun-Huur-Tu; brother of Sayan Bapa</p></td>
</tr>
<tr>
<td><p class="tabh">Anya Xovalyg</p></td>
<td><p class="tabh1">Kaigal-ool’s wife</p></td>
</tr>
<tr>
<td><p class="tabh">Sengedorj</p></td>
<td><p class="tabh1">Mongolian musician and outstanding throat-singer from Hovd City</p></td>
</tr>
<tr>
<td><p class="tabh">Tserendavaa</p></td>
<td><p class="tabh1">Mongolian musician from Chandman Sum, Hovd Aimag</p></td>
</tr>
<tr>
<td><p class="tabh">Tumat Kara-ool</p></td>
<td><p class="tabh1">Throat-singer recorded for Smithsonian Folkways release later licensed for television commercial</p></td>
</tr>
<tr>
<td><p class="tabh"><a id="page_xxiv">Joel Gordon</a></p></td>
<td><p class="tabh1">Recording engineer and radio producer from Boston who participated in Tuvan and Mongolian field research</p></td>
</tr>
<tr>
<td><p class="tabh">David Harrison</p></td>
<td><p class="tabh1">Linguist and advocate for preservation of endangered languages; specialist in Tuvan language and culture</p></td>
</tr>
<tr>
<td><p class="tabh">Sarymai Orchimaev</p></td>
<td><p class="tabh1"><i>Kai</i> singer and multi-instrumentalist from the Altai Republic</p></td>
</tr>
<tr>
<td><p class="tabh">Sat Maar-ool</p></td>
<td><p class="tabh1">Throat-singer and teacher from Teeli, in western Tuva</p></td>
</tr>
<tr>
<td><p class="tabh">Narantsogt</p></td>
<td><p class="tabh1">Elderly <i>tsuur</i> (reed flute) player in Hovd Aimag, western Mongolia</p></td>
</tr>
<tr>
<td><p class="tabh">Gombojav</p></td>
<td><p class="tabh1"><i>Tsuur</i> player from Hovd City, son of Narantsogt</p></td>
</tr>
<tr>
<td><p class="tabh">Albert Saspyk-ool</p></td>
<td><p class="tabh1">Expert mimic of animal sounds from Chyraa-Bajy, Tuva</p></td>
</tr>
<tr>
<td><p class="tabh">Alexander Tülüsh</p></td>
<td><p class="tabh1">Hunter who imitated sound and movement of wolves and other animals</p></td>
</tr>
<tr>
<td><p class="tabh">Aldyn-ool Sevek</p></td>
<td><p class="tabh1">Throat-singer and school teacher from Kyzyl-Xaya, in western Tuva</p></td>
</tr>
<tr>
<td><p class="tabh">Grigori Mongush</p></td>
<td><p class="tabh1">Tuvan musician who transforms visual landscapes into whistled sound sketches</p></td>
</tr>
<tr>
<td><p class="tabh">Evgeni Ulugbashev</p></td>
<td><p class="tabh1">Xakas singer who performs on the <i>chatxan</i> (zither) and composes songs</p></td>
</tr>
<tr>
<td><p class="tabh">Nurlanbek Nyshanov</p></td>
<td><p class="tabh1">Kyrgyz multi-instrumentalist, leader of Ensemble Tengir-Too</p></td>
</tr>
<tr>
<td><p class="tabh">Abdulhamit Raimbergenov</p></td>
<td><p class="tabh1">Kazakh <i>dombra</i> (long-necked lute) player and music educator</p></td>
</tr>
<tr>
<td><p class="tabh">Ruslan Jumabaev</p></td>
<td><p class="tabh1">Kyrgyz <i>komuz</i> (long-necked lute) virtuoso</p></td>
</tr>
<tr>
<td><p class="tabh">Namazbek Uraliev</p></td>
<td><p class="tabh1">Kyrgyz <i>komuz</i> virtuoso</p></td>
</tr>
<tr>
<td><p class="tabh">Deleg Bayansair</p></td>
<td><p class="tabh1">Tuvan singer in Tsengel Sum, western Mongolia</p></td>
</tr>
<tr>
<td><p class="tabh">Mongush Kenin-Lopsan</p></td>
<td><p class="tabh1">Tuvan scholar of shamanism, writer, and cultural revivalist</p></td>
</tr>
<tr>
<td><p class="tabh">Dari Bandi</p></td>
<td><p class="tabh1">Mongolian singer and herder, expert at using sound to manage herd animals</p></td>
</tr>
<tr>
<td><p class="tabh"><a id="page_xxv">Vyacheslav Kuchenov</a></p></td>
<td><p class="tabh1">Xakas musician and epic composer, member of ensemble Sabjilar</p></td>
</tr>
<tr>
<td><p class="tabh">Sergei Charkhov</p></td>
<td><p class="tabh1">Xakas musician and instrument builder, member of ensemble Sabjilar</p></td>
</tr>
<tr>
<td><p class="tabh">Anya Burnakova</p></td>
<td><p class="tabh1">Xakas musician, member of ensemble Sabjilar</p></td>
</tr>
<tr>
<td><p class="tabh">Lazo Mongush</p></td>
<td><p class="tabh1">Tuvan shaman</p></td>
</tr>
<tr>
<td><p class="tabh">Kara-ool Dopchuur</p></td>
<td><p class="tabh1">Tuvan shaman</p></td>
</tr>
<tr>
<td><p class="tabh">Ai-Churek Oyun</p></td>
<td><p class="tabh1">Tuvan shamaness</p></td>
</tr>
<tr>
<td><p class="tabh">Rysbek Jumabaev</p></td>
<td><p class="tabh1">Kyrgyz <i>manaschi</i> (epic singer)</p></td>
</tr>
<tr>
<td><p class="tabh">Tyva Kyzy</p></td>
<td><p class="tabh1b">Female throat-singing group from Tuva whose members include:</p>
<p class="tabh2">Choduraa Tumat</p>
<p class="tabh2">Ailangmaa Damyrang</p>
<p class="tabh2">Ailang Ondar</p>
<p class="tabh2b">Shoraana Kuular</p></td>
</tr>
<tr>
<td><p class="tabh">Raisa Modorova</p></td>
<td><p class="tabh1">Altai singer-songwriter and performer of <i>kai</i> (guttural) vocal style</p></td>
</tr>
<tr>
<td><p class="tabh">Kongar-ool Ondar</p></td>
<td><p class="tabh1">Tuvan throat-singer and informal cultural ambassador</p></td>
</tr>
<tr>
<td><p class="tabh">Svetlana Bapa</p></td>
<td><p class="tabh1">Wife of Huun-Huur-Tu member Sayan Bapa</p></td>
</tr>
<tr>
<td><p class="tabh">Ross Daly</p></td>
<td><p class="tabh1">Irish musician and world music impresario who resides on Crete</p></td>
</tr>
<tr>
<td><p class="tabh">Manos Andriotis</p></td>
<td><p class="tabh1">Greek music producer and world music fan</p></td>
</tr>
<tr>
<td><p class="tabh">Jamchid Chemirani</p></td>
<td><p class="tabh1">Iranian percussionist who performed with Huun-Huur-Tu in Greece</p></td>
</tr>
</tbody></table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_FM02.vue?5f6dee9c